import { createStore, createLogger } from "vuex";

import {
  AuthModule,
  type Store as AuthStore,
  type State as AuthState,
} from "./auth.module/";
import {
  OrderModule,
  type Store as OrderStore,
  type State as OrderState,
} from "./order.module/";
import {
  FormModule,
  type Store as FormStore,
  type State as FormState,
} from "./form.module/";

export type RootState = {
  auth: AuthState;
  order: OrderState;
  form: FormState;
};

export type Store = AuthStore<Pick<RootState, "auth">> &
  OrderStore<Pick<RootState, "order">> &
  FormStore<Pick<RootState, "form">>;

export const store = createStore({
  modules: {
    auth: AuthModule,
    order: OrderModule,
    form: FormModule,
  },
  plugins: import.meta.env.DEV ? [createLogger()] : [],
});

export function useStore(): Store {
  return store as Store;
}
